"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
/**
 * Height and width selector via table.
 * When dimension selected onDimensionsSelect will emit it as an {@link MatrixDimensionModel}
 * Selection maximum height & width will be within given bounds.
 */
var MatrixDimensionPickerComponent = /** @class */ (function () {
    function MatrixDimensionPickerComponent() {
        this.maxHeight = 7;
        this.maxWidth = 9;
        this.onDimensionsSelect = new core_1.EventEmitter();
        this.showSelector = false;
    }
    MatrixDimensionPickerComponent.prototype.ngOnInit = function () {
        this.dummyHeight = new Array(this.maxHeight);
        this.dummyWidth = new Array(this.maxWidth);
    };
    MatrixDimensionPickerComponent.prototype.ngOnChanges = function (change) {
        if (change.maxHeight) {
            this.dummyHeight = new Array(this.maxHeight);
        }
        if (change.maxWidth) {
            this.dummyWidth = new Array(this.maxWidth);
        }
    };
    MatrixDimensionPickerComponent.prototype.changeShowSelector = function () {
        this.showSelector = !this.showSelector;
        if (this.showSelector) {
            this.hoveredDimensions = { height: this.height || 0, width: this.width || 0 };
        }
    };
    MatrixDimensionPickerComponent.prototype.selectDimensions = function () {
        this.onDimensionsSelect.emit({ height: this.hoveredDimensions.height, width: this.hoveredDimensions.width });
    };
    MatrixDimensionPickerComponent.prototype.changeCellHovering = function (height, width) {
        this.hoveredDimensions = height && width ? { height: height, width: width } : { height: 0, width: 0 };
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], MatrixDimensionPickerComponent.prototype, "maxHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], MatrixDimensionPickerComponent.prototype, "maxWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MatrixDimensionPickerComponent.prototype, "height", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], MatrixDimensionPickerComponent.prototype, "width", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], MatrixDimensionPickerComponent.prototype, "onDimensionsSelect", void 0);
    MatrixDimensionPickerComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-matrix-dimension-picker',
            template: require('./matrix-dimension-picker.component.html'),
            styles: [require('./matrix-dimension-picker.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }),
        __metadata("design:paramtypes", [])
    ], MatrixDimensionPickerComponent);
    return MatrixDimensionPickerComponent;
}());
exports.MatrixDimensionPickerComponent = MatrixDimensionPickerComponent;
//# sourceMappingURL=matrix-dimension-picker.component.js.map